import { Modal } from 'antd';

interface KeywordDefinitionHelpModalProps {
  visible: boolean;
  onClose: () => void;
}

const KeywordDefinitionHelpModal = ({
  visible,
  onClose,
}: KeywordDefinitionHelpModalProps) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
      centered
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '24px' }}>🔍</span>
          <span style={{ fontSize: '20px', fontWeight: 700 }}>
            키워드 정의 기능이란?
          </span>
        </div>
      }
    >
      <div>
        <p
          style={{
            fontSize: '16px',
            lineHeight: '1.6',
            color: '#333',
            marginBottom: '20px',
          }}
        >
          사용자가 등록한 키워드에 대해 의미, 맥락, 포함/제외 조건 등을 직접
          정의할 수 있도록 도와주는 기능입니다. <br />이 기능을 통해 키워드가
          문장에서 어떤 의미로 쓰였는지 구체적으로 구분하고, 정확한 데이터만
          선별해 분석할 수 있습니다.
        </p>

        <div style={{ marginBottom: '40px' }}>
          <h3
            style={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#222',
              marginBottom: '4px',
            }}
          >
            예시
          </h3>
          <div style={{ marginBottom: '16px' }}>
            <div
              style={{ fontSize: '15px', color: '#333', marginBottom: '6px' }}
            >
              • 키워드가 '<strong>토스</strong>'일 경우
            </div>
            <div
              style={{
                marginLeft: '16px',
                fontSize: '14px',
                color: '#666',
                lineHeight: '1.5',
              }}
            >
              → 은행 서비스 '토스' 인지, 배구에서 사용하는 용어 '토스' 인지
              구분이 필요합니다
            </div>
          </div>
          <div>
            <div
              style={{ fontSize: '15px', color: '#333', marginBottom: '6px' }}
            >
              • 키워드가 '<strong>배달</strong>'일 경우
            </div>
            <div
              style={{
                marginLeft: '16px',
                fontSize: '14px',
                color: '#666',
                lineHeight: '1.5',
              }}
            >
              → 배달 앱을 의미하는지, 일반적인 사업 이름인지 구분해야 합니다
            </div>
          </div>
        </div>

        <div style={{ marginBottom: '32px' }}>
          <h3
            style={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#222',
              marginBottom: '16px',
            }}
          >
            🎯 이런 분들에게 꼭 필요해요
          </h3>
          <ul
            style={{
              margin: 0,
              paddingLeft: '20px',
              fontSize: '15px',
              lineHeight: '1.6',
              color: '#333',
            }}
          >
            <li style={{ marginBottom: '8px' }}>
              브랜드명, 인물명, 약어 등 다의적인 키워드를 추적하는 분
            </li>
            <li style={{ marginBottom: '8px' }}>
              연관성 높은 데이터만 선별하고 싶은 분
            </li>
            <li>정제된 리포트를 만들고 싶은 마케터, 홍보 담당자</li>
          </ul>
        </div>

        <div
          style={{
            marginBottom: '32px',
            padding: '16px 0',
            borderTop: '1px solid #e0e0e0',
          }}
        >
          <p
            style={{
              fontSize: '15px',
              fontWeight: 500,
              color: '#222',
              margin: 0,
            }}
          >
            📌 수정 버튼을 클릭하여 키워드에 내용을 추가, 삭제하여 고도화가
            가능합니다.
          </p>
        </div>

        <div style={{ textAlign: 'center', marginTop: '32px' }}>
          <button
            onClick={onClose}
            style={{
              padding: '12px 48px',
              backgroundColor: '#4403B5',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            확인
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default KeywordDefinitionHelpModal;
